import { ReactNode } from 'react';

import CheckBox, { CheckboxProps } from '@mui/material/Checkbox';

import { FormControl, FormControlLabel } from '../form/form';
import Checkbox from './checkbox';

type CheckboxFieldProps = CheckboxProps & {
  name?: string;
  fullWidth?: boolean;
  label: ReactNode;
  disabled?: boolean | false;
  updatedStyling?: boolean;
};

const CheckboxField = ({
  size = 'small',
  fullWidth,
  required,
  name,
  label,
  value,
  checked,
  onChange,
  onBlur,
  disabled,
  updatedStyling,
}: CheckboxFieldProps) => {
  return (
    <FormControl required={required} fullWidth={fullWidth} size={size as any}>
      <FormControlLabel
        label={label}
        control={
          <Checkbox
            updatedStyling={updatedStyling}
            name={name}
            value={value}
            size={size}
            checked={checked}
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
          />
        }
      />
    </FormControl>
  );
};

export type { CheckboxProps };
export { CheckBox, CheckboxField };
